<div class="content">
  <div class="content-panel">
    <h2 translate>page.controles.echantillons.title</h2>

<form [formGroup]="formSearchEchantillons" #form="ngForm" (ngSubmit)="onSubmit()" class="search-form">

  <div class="card shadow-sm border-0 mb-3">
    <div class="card-body py-3">
      <div class="row g-3 align-items-end">

        <div class="col-12 col-lg-4">
          <label for="statut" translate class="form-label">
            page.controles.echantillons.search.statut
          </label>
          <select id="statut" formControlName="statut" class="form-select">
            <option [ngValue]="null">{{ 'page.controles.echantillons.search.tous' | translate }}</option>
            <option *ngFor="let statut of statuts" [ngValue]="statut.code">
              {{ statut.libelle }}
            </option>
          </select>
        </div>

        <div class="col-12 col-lg-4">
          <label for="agentPrevu" translate class="form-label">
            page.controles.echantillons.search.agentPrevu
          </label>
          <select id="agentPrevu" formControlName="agentPrevu" class="form-select">
            <option [ngValue]="null">{{ 'page.controles.echantillons.search.tous' | translate }}</option>
            <option *ngFor="let animateur of animateurs" [ngValue]="animateur.id">
              {{ animateur.prenom }} {{ animateur.nom }}
            </option>
          </select>
        </div>

        <div class="col-12 col-lg-4">
          <label class="form-label" translate>
            page.controles.controles.search.numeroCVI
          </label>
          <input type="text" formControlName="numeroCVI" class="form-control" />
        </div>

        <div class="col-12 col-lg-6 d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            (click)="showAdvancedFilters = !showAdvancedFilters"
          >
            {{ showAdvancedFilters ? 'Masquer les filtres' : 'Filtres avancés' }}
          </button>

          <button type="submit" class="btn btn-primary w-100">
            Rechercher
          </button>
        </div>

        <div class="col-12 col-lg-6 d-flex gap-2">
          <button type="button" class="btn btn-outline-primary w-100" (click)="etiquettesPdf()">
            Impression des étiquettes
          </button>
        </div>
      </div>

      <div class="active-filters mt-3" *ngIf="hasActiveFiltersEchantillons()">

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="statutLibelle">
          Statut : {{ statutLibelle }}
          <button type="button" class="chip-close" (click)="clearEchantillonField('statut')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="agentPrevuLibelle">
          Agent prévu : {{ agentPrevuLibelle }}
          <button type="button" class="chip-close" (click)="clearEchantillonField('agentPrevu')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('numeroCVI')?.value">
          CVI : {{ formSearchEchantillons.get('numeroCVI')?.value }}
          <button type="button" class="chip-close" (click)="clearEchantillonField('numeroCVI')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('debutDateButoir')?.value">
          Date butoir début renseignée
          <button type="button" class="chip-close" (click)="clearEchantillonField('debutDateButoir')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('finDateButoir')?.value">
          Date butoir fin renseignée
          <button type="button" class="chip-close" (click)="clearEchantillonField('finDateButoir')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('debutDatePrelevement')?.value">
          Date prélèvement début renseignée
          <button type="button" class="chip-close" (click)="clearEchantillonField('debutDatePrelevement')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('finDatePrelevement')?.value">
          Date prélèvement fin renseignée
          <button type="button" class="chip-close" (click)="clearEchantillonField('finDatePrelevement')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('debutDateCommission')?.value">
          Date commission début renseignée
          <button type="button" class="chip-close" (click)="clearEchantillonField('debutDateCommission')">×</button>
        </span>

        <span class="badge text-bg-light border me-2 mb-2" *ngIf="formSearchEchantillons.get('finDateCommission')?.value">
          Date commission fin renseignée
          <button type="button" class="chip-close" (click)="clearEchantillonField('finDateCommission')">×</button>
        </span>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="resetEchantillonsForm()"
        >
          Tout effacer
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showAdvancedFilters">
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-body py-3">
        <div class="row g-3">

          <div class="col-12 col-md-6 col-xl-3">
            <label for="debutDateButoir" class="form-label" translate>
              page.controles.echantillons.search.dateButoirEntre
            </label>
            <div class="input-group">
              <input
                id="debutDateButoir"
                ngbDatepicker
                #debutDatepickerButoir="ngbDatepicker"
                formControlName="debutDateButoir"
                class="form-control"
              />
              <button type="button" (click)="debutDatepickerButoir.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="finDateButoir" class="form-label" translate>
              page.controles.echantillons.search.et
            </label>
            <div class="input-group">
              <input
                id="finDateButoir"
                ngbDatepicker
                #finDatepickerButoir="ngbDatepicker"
                formControlName="finDateButoir"
                class="form-control"
              />
              <button type="button" (click)="finDatepickerButoir.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="debutDatePrelevement" class="form-label" translate>
              page.controles.echantillons.search.datePrelevementEntre
            </label>
            <div class="input-group">
              <input
                id="debutDatePrelevement"
                ngbDatepicker
                #debutDatepickerPrelevement="ngbDatepicker"
                formControlName="debutDatePrelevement"
                class="form-control"
              />
              <button type="button" (click)="debutDatepickerPrelevement.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="finDatePrelevement" class="form-label" translate>
              page.controles.echantillons.search.et
            </label>
            <div class="input-group">
              <input
                id="finDatePrelevement"
                ngbDatepicker
                #finDatepickerPrelevement="ngbDatepicker"
                formControlName="finDatePrelevement"
                class="form-control"
              />
              <button type="button" (click)="finDatepickerPrelevement.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="debutDateCommission" class="form-label" translate>
              page.controles.echantillons.search.dateCommissionEntre
            </label>
            <div class="input-group">
              <input
                id="debutDateCommission"
                ngbDatepicker
                #debutDatepickerCommission="ngbDatepicker"
                formControlName="debutDateCommission"
                class="form-control"
              />
              <button type="button" (click)="debutDatepickerCommission.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <label for="finDateCommission" class="form-label" translate>
              page.controles.echantillons.search.et
            </label>
            <div class="input-group">
              <input
                id="finDateCommission"
                ngbDatepicker
                #finDatepickerCommission="ngbDatepicker"
                formControlName="finDateCommission"
                class="form-control"
              />
              <button type="button" (click)="finDatepickerCommission.toggle()" class="btn btn-outline-secondary">
                <fa-icon icon="calendar-alt"></fa-icon>
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</form>
    <div class="table-responsive" *ngIf="echantillons?.length > 0; else aucunEchantillon">
      <table class="table" aria-label="Liste des echantillons">
        <thead>
          <th translate>page.controles.echantillons.table.cvi</th>
          <th translate>page.controles.echantillons.table.raisonSociale</th>
          <th translate>page.controles.echantillons.table.produit</th>
          <th translate>page.controles.echantillons.table.siteStockage</th>
          <th translate>page.controles.echantillons.table.statut</th>
          <th translate>page.controles.echantillons.table.numeroDossier</th>
          <th translate>page.controles.echantillons.table.dateButoir</th>
          <th translate>page.controles.echantillons.table.agent</th>
          <th translate>page.controles.echantillons.table.datePrelevement</th>
          <th translate>page.controles.echantillons.table.dateCommission</th>
          <th translate>page.controles.echantillons.table.numeroCommission</th>
          <th></th>
        </thead>

        <tbody>
          <tr *ngFor="let echantillon of echantillons">
            <td>{{ echantillon.cvi }}</td>
            <td>{{ echantillon.operateur?.raisonSociale }}</td>
            <td>{{ echantillon.libelleProduit }}</td>
            <td>{{ echantillon.adresseSite }}</td>
            <td>{{ echantillon.statut?.libelle }}</td>
            <td>{{ echantillon.numeroDossier }}</td>
            <td [ngClass]="{ 'dateButoirDepassee': echantillon.estPerime() && echantillon.statut?.code==='A_PRELEVER'}">
              {{ echantillon.dateButoir | date:'dd/MM/yyyy' }}</td>
            <td>{{ echantillon.animateur?.prenom }} {{ echantillon.animateur?.nom }}</td>
            <td>{{ echantillon.datePrelevement | date:'dd/MM/yyyy' }}</td>
            <td>{{ echantillon.dateCommission | date:'dd/MM/yyyy' }}</td>
            <td>{{ echantillon.numeroCommission }}</td>
            <td>
              <span>
                <button type="button" class="btn btn-outline-secondary btn-add"
                  *ngIf="echantillon.codeStatut === 'A_PRELEVER'" (click)="onAddPrelevement(echantillon)">
                  <fa-icon icon="plus" class="primary-icon" title="Saisir un prélèvement"></fa-icon>
                </button>
                <button *ngIf="false" style="margin-left: 1em;" type="button" class="btn btn-outline-secondary btn-add"
                  (click)="telechargerDocument(echantillon)">
                  <fa-icon icon="download" class="primary-icon" title="Télécharger le document"></fa-icon>
                </button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination-bar [pagination]="pagination"></app-pagination-bar>
  </div>
</div>

<ng-template #aucunEchantillon>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon>
    page.controles.echantillons.search.aucunEchantillon
  </div>
</ng-template>

